export interface FunnelStep {
  id: string;
  label: string;
  icon: string;
  users: number;
  conversionRate: number;
  dropOff: number;
  color: string;
}

export interface CampaignFunnelRow {
  id: number;
  campaign: string;
  impressions: number;
  views: number;
  clicks: number;
  whatsappClicks: number;
  formSubmits: number;
  conversionRate: number;
  dropOffRate: number;
}

export const funnelSteps: FunnelStep[] = [
  { id: 'landing', label: 'Landing Sayfa', icon: 'ri-layout-line', users: 12840, conversionRate: 100, dropOff: 0, color: '#D4AF37' },
  { id: 'campaign_view', label: 'Kampanya Görüntüleme', icon: 'ri-megaphone-line', users: 8920, conversionRate: 69.5, dropOff: 30.5, color: '#E8C87C' },
  { id: 'video_play', label: 'Video Oynatma', icon: 'ri-play-circle-line', users: 5640, conversionRate: 43.9, dropOff: 36.8, color: '#F4C2C2' },
  { id: 'button_click', label: 'Buton Tıklama', icon: 'ri-cursor-line', users: 3890, conversionRate: 30.3, dropOff: 31.0, color: '#FFD0DB' },
  { id: 'whatsapp_click', label: 'WhatsApp Tıklama', icon: 'ri-whatsapp-line', users: 2240, conversionRate: 17.4, dropOff: 42.4, color: '#A5D6A7' },
  { id: 'form_start', label: 'Form Başlatma', icon: 'ri-file-edit-line', users: 1580, conversionRate: 12.3, dropOff: 29.5, color: '#FFCC80' },
  { id: 'form_submit', label: 'Form Gönderimi', icon: 'ri-checkbox-circle-line', users: 980, conversionRate: 7.6, dropOff: 38.0, color: '#80CBC4' },
  { id: 'lead_created', label: 'Lead Oluşturuldu', icon: 'ri-user-add-line', users: 887, conversionRate: 6.9, dropOff: 9.5, color: '#CE93D8' },
];

export const funnelCompareSteps = [
  { id: 'landing', current: 12840, previous: 10200 },
  { id: 'campaign_view', current: 8920, previous: 6800 },
  { id: 'video_play', current: 5640, previous: 4200 },
  { id: 'button_click', current: 3890, previous: 2900 },
  { id: 'whatsapp_click', current: 2240, previous: 1780 },
  { id: 'form_start', current: 1580, previous: 1100 },
  { id: 'form_submit', current: 980, previous: 720 },
  { id: 'lead_created', current: 887, previous: 652 },
];

export const campaignFunnelRows: CampaignFunnelRow[] = [
  { id: 1, campaign: 'Botoks & Dolgu Paketi', impressions: 28400, views: 4280, clicks: 1840, whatsappClicks: 620, formSubmits: 342, conversionRate: 8.0, dropOffRate: 25.4 },
  { id: 2, campaign: 'Lazer Epilasyon 6 Seans', impressions: 22100, views: 3640, clicks: 1290, whatsappClicks: 480, formSubmits: 218, conversionRate: 6.0, dropOffRate: 28.7 },
  { id: 3, campaign: 'İpek Kirpik Komple', impressions: 15600, views: 2910, clicks: 980, whatsappClicks: 310, formSubmits: 156, conversionRate: 5.4, dropOffRate: 31.2 },
  { id: 4, campaign: 'Dermapen Cilt Yenileme', impressions: 18200, views: 2450, clicks: 890, whatsappClicks: 280, formSubmits: 189, conversionRate: 7.7, dropOffRate: 22.1 },
  { id: 5, campaign: 'Saç Mezoterapisi 4 Seans', impressions: 9800, views: 1870, clicks: 540, whatsappClicks: 180, formSubmits: 93, conversionRate: 5.0, dropOffRate: 35.8 },
  { id: 6, campaign: 'Komple SPA Günü', impressions: 24500, views: 3200, clicks: 1380, whatsappClicks: 490, formSubmits: 274, conversionRate: 8.6, dropOffRate: 21.3 },
  { id: 7, campaign: 'Hydra Facial Gençlik', impressions: 14200, views: 2100, clicks: 760, whatsappClicks: 240, formSubmits: 201, conversionRate: 9.6, dropOffRate: 19.8 },
];

export const dropOffChartData = [
  { step: 'Landing→Kampanya', dropOff: 30.5 },
  { step: 'Kampanya→Video', dropOff: 36.8 },
  { step: 'Video→Buton', dropOff: 31.0 },
  { step: 'Buton→WhatsApp', dropOff: 42.4 },
  { step: 'WhatsApp→Form', dropOff: 29.5 },
  { step: 'Form→Gönderim', dropOff: 38.0 },
  { step: 'Gönderim→Lead', dropOff: 9.5 },
];
